// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.immunization.PatientVaccinationResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientVaccinationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	administeredAmount!: number | null;

	@GandalfProperty({ designType: Number })
	administeredAmountUnitId!: number | null;

	@GandalfProperty({ designType: Number })
	administeredAtLocationId!: number | null;

	@GandalfProperty({ designType: Number })
	administeredByEmployeeId!: number | null;

	@GandalfProperty({ designType: Date })
	administeredOn!: Date | null;

	@GandalfProperty({ designType: Number })
	administeredRouteId!: number | null;

	@GandalfProperty({ designType: Number })
	administeredSiteId!: number | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: String })
	cvxDetailCode!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	endDate!: Date | null;

	@GandalfProperty({ designType: Boolean })
	notGiven!: boolean | null;

	@GandalfProperty({ designType: Number })
	notGivenReasonId!: number | null;

	@GandalfProperty({ designType: Number })
	orderedByProviderId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	substanceExpireDate!: Date | null;

	@GandalfProperty({ designType: String })
	substanceLot!: string | null;

	@GandalfProperty({ designType: String })
	substanceManufacturerId!: string | null;

	@GandalfProperty({ designType: Number })
	vaccinationId!: number | null;

}
